import { useUserConfig } from "./useUserConfig";
import { UserPermission } from "../contexts/UserConfigContext";

export const useUserPermission = (permission: UserPermission) => {
  const { permissions } = useUserConfig();
  return permissions[permission];
};
